import { getAdminAxiosInstance } from "../../../api/Admin";


export const fetchMenuData = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/product/fetch-menu`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const posistMenuFetchingData = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/posist-fetch-menu?store_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const ManualMenuFetching = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/product/fetch-menu-all`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const copyStoreMenu = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/store/copy-store-menu`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const getSeasonalStoreEditData = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/seasonal-timing/edit?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
